import enhanceDataTable from './enhanceDataTableFork';
import PartialTable from './CustomPartialTable';

export default enhanceDataTable(PartialTable);
